import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableHighlight,
  Button,
  View,
} from 'react-native';

import FirebaseConsult from '../firebase/firebase_consult.js'
import FirebaseUsers from '../firebase/firebase_users.js'

import EonnStars from '../components/stars';
import EonnTitle from '../components/title';
import EonnEllipsis from '../components/ellipsis';
import EonnButton from '../components/button';
import { mstyles } from '../constants/MainStyles';
import common from '../common';
import Messaging from '../messaging.js';


export default class Screen extends Component {

  constructor(props) {
    super(props);
    
    this.initializeConsult();
  }

  async initializeConsult() {
    try {
      await FirebaseUsers.uploadConsultMedia();
      await FirebaseConsult.updateConsultInfo();
      
      // await Messaging.sendSMS(
      //   "9843580947",
      //   "A new issue has been posted to Auto TeleTech: " + global.consult.desc + (global.user.techLink ? " | Tech Link: " + global.user.techLink : "")
      // );
      
      // await Messaging.sendSMS(
      //   "7138706742",
      //   "A new issue has been posted to Auto TeleTech: " + global.consult.desc + (global.user.techLink ? " | Tech Link: " + global.user.techLink : "")
      // );

      if (global.techLink) {
        await Messaging.sendSMS(
          global.techLinkBid.t_phone,
          "You have a new consultation request for: " + global.consult.desc + ". Please check your dashboard at https://consult.autoteletech.com/?side=tech"
        );
        console.log("sms response: ", "All SMS sent successfully");
      } else {
        await Messaging.sendSMS(
          "9843580947",
          "There is a new marketplace consultation request for: " + global.consult.desc + ".  Visit https://consult.autoteletech.com/?side=tech to review the request."
        );
        console.log("sms response: ", "No SMS sent");
      }
      
      console.log("consult updated");
      console.log("consult: ", global.consult);
      
      this.props.navigation.reset({
        index: 0,
        routes: [{ name: 'C_Request1' }],
      });
      
    } catch (error) {
      console.error("Error initializing consult:", error);
      // todo: show error message to user
    }
  }

  render() {
    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>
        <Text style={[mstyles.text,{paddingTop:100, paddingBottom:100}]}>Setting up your consult
        <EonnEllipsis style={[mstyles.mfont]}/></Text>
      </ScrollView>
    );
  }
}